// extracted by mini-css-extract-plugin
export default {"card":"MessageCard_card__A0s4M","title":"MessageCard_title__IggFi","paragraph":"MessageCard_paragraph__u85fC"};